import {Component, OnInit, ViewChild} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {SharepointService} from 'app/services/sharepoint.service';
import {CompetitionService} from 'app/services/competition.service';
import {Competition} from 'app/models/competition';
import {StadiumCamerasService} from 'app/services/stadium-cameras.service';
import {PannellumStadiumCamera} from 'app/models/pannellum-stadium-camera';
import {Stadium} from 'app/models/stadium';
import {Source} from 'app/models/source.enum';
import { Observable, of, zip } from 'rxjs';
import { CompetitionBackgroundComponent } from 'app/shared/components/competition-background/competition-background.component';
import { CompetitionLogoComponent } from 'app/shared/components/competition-logo/competition-logo.component';
import {DialogHelperService} from '../../services/dialog-helper.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-competition',
    templateUrl: './competition.component.html',
    styleUrls: ['./competition.component.scss']
})
export class CompetitionComponent implements OnInit {
    date: Date = new Date();
    competition: Competition;
    @ViewChild('bgcompetition') bgComponent: CompetitionBackgroundComponent;
    @ViewChild('stcompetition') stComponent: CompetitionBackgroundComponent;
    @ViewChild('ftcompetition') ftComponent: CompetitionBackgroundComponent;
    @ViewChild('lgcompetition') lgComponent: CompetitionLogoComponent;
    constructor(private router: Router,
        private route: ActivatedRoute,
        private competitionService: CompetitionService,
        private stadiumCamerasService: StadiumCamerasService,
        private dialogHelper: DialogHelperService,
        private sharepointService: SharepointService
    ) {
        this.competition = new Competition(null, null, null, null, null, null);
        this.competition.is_public = false;
    }

    ngOnInit() {}

    onDiscard() {
        this.competition = new Competition(null, null, null, null, null, null);
        this.competition.is_public = false;
        this.bgComponent.cancel();
        this.stComponent.cancel();
        this.ftComponent.cancel();
        this.lgComponent.cancel();
    }

    onSave() {
        this.stadiumCamerasService.getDefaultPannellumStadiumCameras()
            .subscribe(pannellumStadiumCameras => {
                this.createCompetition(pannellumStadiumCameras);
            });
    }

    onFileError(size: number) {
      this.dialogHelper.showPrompt(
        'File too big error',
        'Uploaded file is too big. Choose a file below 400 KB. Your file was: '
        + size.toString()
        + ' KB',
        'OK',
        () => {}
      );
    }

    private createCompetition(pannellumStadiumCameras: PannellumStadiumCamera[]): void {

        const background: Blob = this.competition.backgroundUrl;
        const stadiumbg: Blob = this.competition.stadiumUrl;
        const footerImage: Blob = this.competition.footerImageUrl;
        delete this.competition.backgroundUrl;
        delete this.competition.stadiumUrl;
        delete this.competition.footerImageUrl;
        this.competition.has_footer_image = !!footerImage;
        console.log('Background BLOB to be uploaded', background);
        this.competitionService.create(this.competition)
            .subscribe(res => {
              zip(
                this.sharepointService.upSharepointFile(Object.assign(res.assetBackground, {
                mimeType: 'image/*',
              }), background),
              this.sharepointService.upSharepointFile(Object.assign(res.assetStadium, {
                mimeType: 'image/*',
              }), stadiumbg),
              footerImage ? this.sharepointService.upSharepointFile(Object.assign(res.assetFooterImage, {
                mimeType: 'image/*',
              }), footerImage) : of(null)).subscribe(result => {
                console.log('returned upload zip', result);
                const competitions = this.competitionService.getCompetitions();
                competitions.push(res);
                console.log('COMPETITION SAVED ', res);
                this.competitionService.setCompetitions(competitions);
                this.competitionService.setCompetitionSelected(res);

                const stadium = new Stadium(null, res.id, 'Stadium', Date.now(),
                    Source.Stadium, pannellumStadiumCameras);
                console.log('Stadium to create', stadium);
                this.stadiumCamerasService.create(stadium)
                    .subscribe(el => {
                        this.router.navigate(['competition', res.compUrl,
                            'onboarding'],
                            {relativeTo: this.route.parent});
                    });
              });
            }, error => {
              console.log('error on creating competition');
              console.log(error);
              if (!!!error.handled) {
                if (typeof error.error === 'object') {
                  this.dialogHelper.showPrompt(
                    'Unable to create competition',
                    error.statusText,
                    'OK',
                    () => {}
                  );
                } else {
                  this.dialogHelper.showPrompt(
                    'Unable to create competition',
                    error.error,
                    'OK',
                    () => {}
                  );
                }
              }
            });
    }
}
